module.exports = __webpack_public_path__ + "img/speaker-2.e905e8d2.png";